<template>
  <container
    subHeaderTitle="PASS프라임<br /><b>가입하기</b>"
    subHeaderText="서비스 가입 전 이용약관을 반드시 읽어보시고,<br />가입하시는 분의 정보를 정확히 입력하시기 바랍니다."
    subHeaderAlign="center"
  >
    <template v-slot="{showPrimeTerms}">
      <section class="form-area">
        <v-container class="py-0">
          <v-row justify="center">
            <v-col cols="12" md="6" sm="8">
              <v-form v-model="valid" ref="form" onsubmit="return false;">
                <p>휴대폰번호</p>
                <div class="d-flex">
                  <v-select
                    :items="items" 
                    item-text="text" 
                    item-value="value" 
                    v-model="teleCoCd" 
                    @change="chkClear()"
                    solo
                  />
                  <v-text-field
                    ref="cellTelNo"
                    v-model="cellTelNo"
                    :rules="rules.cellTelNoRules"
                    label="'-'를 제외하고 입력"
                    mask="###########"
                    required
                    solo
                    maxlength="11"
                    @keyup="replaceNan('cellTelNo')"
                  />              
                </div>
                <div class="check-all">
                  <v-checkbox label="모든 약관 동의" v-if="teleCoCd == '1'" v-model="chk_all" @change="checkAll()" />
                </div>
                <v-divider class="mt-2 mb-5" />
                <div class="check-item d-flex justify-space-between align-center" v-for="(term, index) in sktTerms" :key="index">
                  <v-checkbox v-model="term.isChecked" hide-details @change="checkBoxCheck()" :rules="term.isRequired ? rules.checkBoxRule: []">
                    <template v-slot:label>
                      <div>{{ term.termTitle }}</div>
                    </template>
                  </v-checkbox>
                  <div class="ml-auto">
                    <button type="button" @click.stop="showDialog(showPrimeTerms, term.termsCd)">
                      <v-icon>mdi-chevron-right</v-icon>
                    </button>
                  </div>
                </div>
                <div class="recaptcha-area">
                  <vue-recaptcha ref="recaptcha" v-model="recaptchaVerify" @verify="onVerify" @expired="onExpired" :sitekey="$cfg.recaptchaSiteKey"></vue-recaptcha>
                  <div class="v-messages theme--light error--text mt-2">
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message" v-if="!recaptchaVerifyCheck">로봇이 아닙니다를 체크해주세요</div>
                    </div>
                  </div>
                </div>
                <div>
                  <v-btn class="submit" rounded block large depressed color="primary" @click.stop="submit"
                  :data-ga-category="gaEvent.category.support.prime.contract.name" :data-ga-label="gaEvent.category.support.prime.contract.label1" :data-ga-action="gaEvent.actions.buttonClick"
                  >가입하기</v-btn>
                </div>
                <p class="mt-8 text-center">매월 3,960원 (VAT포함)</p>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </section>
      <div class="mb-16">
        <v-container>
          <v-row justify="center">
            <v-col cols="12" md="4" sm="6">
              <div class="text-center term-btn">
                <v-btn text @click="showDialog(showPrimeTerms,  '002')">서비스이용약관</v-btn>
                <span class="mx-1">|</span>
                <v-btn text href="https://m.privacy.sktelecom.com/main.do?result=0000&amp;resultMessage=ok" target="_blank">개인정보처리방침</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </template>
  </container>
</template>

<style lang="scss" scoped>
@import "~@/styles/cscenter";
</style>

<script>
import Container from "@/pages/container/index.vue";
import PassSafeguardContract from "@/views/csCenter/PassSafeguardContract.vue";
import {GaTracking} from "@/mixins/index.js";


export default {
  mixins: [PassSafeguardContract, GaTracking],
  name: "PassPrimeContract",
  components: {
    Container
  },
  data() {
    return {
      chk_all: false,
      rules: {
        cellTelNoRules: [(v) => !!v || "휴대폰번호를 입력하세요.", (v) => (v && v.length === 11 && /(010)([1-9]{1}[0-9]{3})([0-9]{4})$/.test(v)) || "휴대폰번호가 정확하지 않습니다."],
        checkBoxRule: [(v) => !!v || '필수 약관에 동의해주세요']
      },
      items: [
        { text: 'SKT', value: '1' },
        // { text: 'KT', value: '2' },
        // { text: 'LG U+', value: '3' }
      ],
      sktTerms: [
        {
          termTitle: "PASS프라임 서비스 이용약관(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "461"
        },
        {
          termTitle: "PASS머니 서비스 이용약관(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "462"
        },
        {
          termTitle: "PASS머니 개인정보수집 및 이용동의(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "467"
        },
        {
          termTitle: "금융인증 서비스 이용 약관(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "477"
        },
        {
          termTitle: "KCB 신용정보서비스 이용약관(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "463"
        },
        {
          termTitle: "주식정보 서비스 이용약관(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "464"
        },
        {
          termTitle: "금융정보 이용약관(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "465"
        },
        {
          termTitle: "개인정보 수집/이용 동의(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "466"
        },
        {
          termTitle: "개인정보 제3자 제공 동의(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "468"
        },
        {
          termTitle: "핀브릿지 개인정보 제3자 제공(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "481"
        },
        {
          termTitle: "KCB 신용정보 수집/이용 동의(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "469"
        },
        {
          termTitle: "신용정보 푸시 수신 여부(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "470"
        },
        {
          termTitle: "금융인증 푸시 수신 여부(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "471"
        },
        {
          termTitle: "금융정보 푸시 수신 여부(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "473"
        },
        {
          termTitle: "주식정보 푸시 수신 여부(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "472"
        },
        {
          termTitle: "KCB 신용정보 제3자제공 동의(필수)",
          isChecked: false,
          isRequired: true,
          internalTermsCd: "RQT001",
          termsCd: "478"
        },
        // {
        //   termTitle: "마케팅목적 개인(신용)정보 수집/이용/제3자 동의 (선택)",
        //   isChecked: false,
        //   isRequired: false,
        //   internalTermsCd: "MA0001",
        //   termsCd: "474"
        // },
        {
          termTitle: "PASS프라임 광고성 정보 수신동의(선택)",
          isChecked: false,
          isRequired: false,
          internalTermsCd: "MA0002",
          termsCd: "475"
        },
        {
          termTitle: "PASS머니 서비스 알림 수신 동의(선택)",
          isChecked: false,
          isRequired: false,
          internalTermsCd: "PM0001",
          termsCd: "476"
        }
      ]
    };
  },

  computed: {
    prdtNo() {
      let prdtNo;
      switch (this.teleCoCd) {
        case "1":
          prdtNo = "P001"; //TODO 프라임 상품번호 입력 필요
          break;
        case "2":
          prdtNo = "P003";
          break;
        case "3":
          prdtNo = "P002";
          break;
        default:
          prdtNo = "P001";
          break;
      }
      return prdtNo;
    }
  },

  methods: {
    checkAll() {
      let allChecked = this.sktTerms.every(term=> term.isChecked)
      if (!allChecked) {
        this.sktTerms.forEach(term => {
          term.isChecked = true
        })
      } else {
        this.sktTerms.forEach(term => {
          term.isChecked = false
        })
      }
      this.checkBoxCheck();
    },
    checkBoxCheck() {
      this.chk_all = this.sktTerms.every(term => {
        return term.isChecked
      })
    },
    checkOptionalAgree(internalTermsCd) {
      const optionalTerm = this.sktTerms.find(term => term.internalTermsCd === internalTermsCd)
      return optionalTerm.isChecked;
    },
    submit(e) {
      this.gaTracking(e);
      this.recaptchaVerifyCheck = this.recaptchaVerify;
      this.$refs.form.validate();

      if (!this.valid) {
        return false;
      }
      if (!this.recaptchaVerify) {
        return false;
      }

      this.$router.push({
        name: "PassPrimeCert",
        params: {
          type: "contract",
          teleCoCd: this.teleCoCd,
          cellTelNo: this.cellTelNo,
          agreeInfoList : [
            {
              termSeq: "RQT001",
              agreeYn: "Y"
            },
            {
              termSeq: "kcMktInfoYn",
              agreeYn: "N"
            },
            {
              termSeq: "mktRecvYn",
              agreeYn: this.checkOptionalAgree("MA0002") ? "Y" : "N"
              // agreeYn: "N"
            },
            {
              termSeq: "pmPushYn",
              agreeYn: this.checkOptionalAgree("PM0001") ? "Y" : "N"
            }
          ]
        }
      });
    },

    showDialog(showPrimeTerms, termsCd) {
      showPrimeTerms({termsCd: termsCd, prdtNo: this.prdtNo, teleCoCd: this.teleCoCd});
    },
  }
};
</script>
